import type { SVGProps } from "react";
export interface FootballIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FootballIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FootballIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.602 1.448a1.126 1.126 0 0 1 .9 2.058l-2.377 1.188v2.732l2.876 2.09 2.597-.845.397-2.628.023-.112a1.125 1.125 0 0 1 2.202.448l-.416 2.76 1.96 1.989.076.086a1.125 1.125 0 0 1-1.595 1.57l-.085-.077-1.866-1.896-2.597.846-1.099 3.38 1.605 2.211 2.624-.435.114-.013a1.125 1.125 0 0 1 .255 2.232l-2.755.457-1.285 2.479a1.126 1.126 0 0 1-1.998-1.037l1.225-2.362-1.604-2.209h-3.557l-1.607 2.21 1.226 2.36.048.106a1.125 1.125 0 0 1-1.986 1.031l-.058-.1-1.287-2.478-2.753-.457-.113-.025a1.126 1.126 0 0 1 .367-2.207l.115.013 2.62.435 1.606-2.21-1.1-3.381-2.596-.845-1.866 1.895a1.125 1.125 0 0 1-1.602-1.58L3.194 9.14l-.415-2.76-.01-.114a1.125 1.125 0 0 1 2.213-.334l.022.112.396 2.628 2.597.844 2.878-2.09v-2.73L8.496 3.507a1.125 1.125 0 0 1 1.007-2.012l2.496 1.248 2.497-1.248.106-.046Zm-5.085 9.744.948 2.918h3.069l.946-2.918L12 9.391l-2.482 1.801Z"
      />
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
    </svg>
  );
}
